export default {
	er_cover_default_title: 'Обзор эффективности',
	er_page_success_metrics: 'Что изменилось в этом месяце',
	er_page_success_metrics_range: 'Что изменилось за этот период',
	er_page_success_metrics_week: 'Что изменилось на этой неделе',
	er_page_comparison: 'Сравнительная сводка',
	er_page_period_summary: 'Сводка за месяц',
	er_page_period_summary_range: 'Сводка за период',
	er_page_period_summary_week: 'Сводка за неделю',
	er_page_each_month: 'Каждый месяц',
	er_page_rooms: 'Помещения',
	er_rooms_note: 'Каждое помещение в {month}, лучший балл сверху.',
	er_page_shift_comparison: 'Сравнение по сменам',
	er_page_shift_summary: 'По сменам',
	er_page_response_time: 'Среднее время реакции (мин)',
	er_page_avg_score: 'Оценка впечатления',
	er_page_complaints_vs_visits: 'Жалобы и посещения',
	er_page_performance_trends: 'Динамика показателей',
	er_page_complaint_drivers: 'Причины жалоб',

	er_board_working: 'Улучшилось к {month}',
	er_board_attention: 'Требует внимания к {month}',
	er_board_empty: 'В этом месяце нет существенных изменений.',
	er_board_empty_range: 'За этот период нет существенных изменений.',
	er_board_empty_week: 'На этой неделе нет существенных изменений.',
	er_findings_intro: 'Сравнение с {month}. Показаны только существенные изменения.',
	er_verdict_improved: 'Улучшилось',
	er_verdict_watch: 'Требует внимания',

	er_col_metric: 'Показатель',
	er_col_avg: 'Средн. YTD',
	er_col_lifetime_avg: 'Средн. с начала работы',
	er_comparison_note: 'Средн. YTD — значение с января по {month}.',
	er_lifetime_note: 'С начала работы — среднемесячное значение с первого дня с данными по {month}.',
	er_comparison_note_week: 'Неделя отчёта сравнивается с выбранной предыдущей неделей.',
	er_period_only_note: 'Показатели только за {month}.',
	er_each_month_note: 'Каждый месяц выбранного периода. Месяц без данных остаётся пустым.',
	er_col_inc_dec: 'Изм.',
	er_col_complaint: 'Жалоба',
	er_col_qty: 'Кол-во',
	er_total: 'Итого',

	er_metric_avg_score: 'Оценка впечатления',
	er_metric_avg_response_time: 'Среднее время реакции',
	er_metric_cleaner_arrivals: 'Приходы клинеров',
	er_metric_supervisor_inspections: 'Проверки супервайзеров',
	er_metric_complaints_vs_visits_pct: 'Жалобы к посещениям (%)',
	er_metric_complaints: 'Жалобы',
	er_metric_customer_visits: 'Посещения',
	er_metric_expired_slas: 'Просроченные SLA',
	er_unit_min: 'мин',
	er_stat_expected_sla: 'Ожидаемый SLA',
	er_stat_vs_minutes: 'к {value} в {month}',
	er_stat_vs_count: 'к {value} в {month}',
	er_label_complaints: 'Жалобы',
	er_label_visits: 'Посещения',
	er_label_complaints_per_visits: 'Жалобы / посещения',
	er_chart_ratio: 'Доля жалоб к посещениям',
	er_chart_ytd_window: 'С января по {month}.',
	er_cv_formula: 'Жалобы, делённые на посещения санузлов, в процентах: ({complaints} ÷ {visits}) × 100 = {ratio}% в {month}.',
	er_export_kpis_title: 'Что входит в отчёт',
	er_export_kpis_desc: 'Всё это есть в отчёте. Выключите показатель, чтобы убрать его.',
	er_export_select_all: 'Выбрать всё',
	er_export_clear_all: 'Снять всё',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Период отчёта',
	er_export_grain: 'Отчёт по',
	er_export_grain_month: 'Месяц',
	er_export_grain_week: 'Неделя',
	er_export_week_starts: 'Неделя начинается в',
	er_export_week_starts_sunday: 'воскресенье',
	er_export_week_starts_monday: 'понедельник',
	er_export_report_month: 'Месяц отчёта',
	er_export_from_month: 'С месяца',
	er_export_to_month: 'По месяц',
	er_export_period_note_range: 'Отчёт суммирует каждый месяц от начала до конца. При включённом сравнении берётся предыдущий период той же длины. Показатели с начала года по-прежнему считаются с января по конечный месяц.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} против {compare}',
	er_export_compare_range_note: 'Предыдущий период той же длины.',
	er_export_report_week: 'Неделя отчёта',
	er_export_compare_month: 'Сравнить с',
	er_export_shift: 'Смена',
	er_export_shift_all: 'Все смены',
	er_export_no_shifts: 'На этом объекте нет активных смен.',
	er_export_render_failed: 'Не удалось правильно сформировать отчёт, поэтому он не был загружен. Обновите страницу и попробуйте снова.',
	er_export_comparison: 'Сравнение',
	er_export_include_previous: 'Включить предыдущий период',
	er_export_comparison_on: 'Вкл.',
	er_export_comparison_off: 'Выкл.',
	er_export_no_previous_data: 'До этого периода нет данных, поэтому сравнивать не с чем.',
	er_export_compare_previous: 'Предыдущий месяц',
	er_export_compare_previous_week: 'Предыдущая неделя',
	er_export_compare_last_year: 'Тот же месяц год назад',
	er_export_no_periods: 'Для экспорта отчёта на объекте нужен хотя бы один месяц данных.',
	er_export_no_periods_week: 'Для экспорта отчёта на объекте нужна хотя бы одна неделя данных.',
	er_export_period_note: 'Показаны только месяцы с данными. Показатели с начала года всегда охватывают январь — месяц отчёта.',
	er_export_period_note_week: 'Показаны только недели с данными. Сравнение всегда с более ранней неделей.',
	er_export_period_note_single_week: 'Показаны только недели с данными.',

	er_find_response_time_title: 'Среднее время реакции',
	er_find_response_time_change:
		'Изменилось с {previous} до {current} минут ({change}).',
	er_find_avg_score_title: 'Оценка впечатления',
	er_find_score_eased: 'Снизился с {previous} до {current}.',
	er_find_score_improved: 'Вырос с {previous} до {current}.',
	er_find_score_ytd_inline: 'Совпадает со среднегодовым значением {ytd}.',
	er_find_score_ytd_inline_range: 'Совпадает со средним с января по {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Среднее с начала года: {ytd}.',
	er_find_score_ytd_against_range: 'Среднее с января по {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Доля жалоб к посещениям',
	er_find_complaints_ratio_improved: 'Улучшилось с {previous} до {current}.',
	er_find_complaints_ratio_rose: 'Изменилось с {previous} до {current}.',

	er_nar_cv_year_improved: 'Жалобы относительно посещений санузлов улучшились с {from} до {to} за год.',
	er_nar_cv_year_rose: 'Жалобы относительно посещений санузлов выросли с {from} до {to} за год.',
	er_nar_cv_moved: 'Жалобы относительно посещений санузлов изменились с {previous} до {current}.',
	er_nar_cv_current: 'Жалобы относительно посещений санузлов составляют {current}.',
	er_nar_types_total: 'Всего жалоб {total}.',
	er_nar_types_1: 'Главная жалоба: {a} ({ap}%).',
	er_nar_types_2: 'Главная жалоба: {a} ({ap}%), затем {b} ({bp}%).',
	er_nar_types_3: 'Главная жалоба: {a} ({ap}%), затем {b} ({bp}%) и {c} ({cp}%).',
	er_find_rooms_slowest: 'Помещения с самым долгим временем реакции в этом месяце: {rooms}.',
	er_find_rooms_slowest_range: 'Помещения с самым долгим временем реакции за этот период: {rooms}.',
	er_find_rooms_slowest_week: 'Помещения с самым долгим временем реакции на этой неделе: {rooms}.',
	er_find_rooms_lowest_score: 'Помещения с самым низким баллом в этом месяце: {rooms}.',
	er_find_rooms_lowest_score_range: 'Помещения с самой низкой оценкой за этот период: {rooms}.',
	er_find_rooms_lowest_score_week: 'Помещения с самым низким баллом на этой неделе: {rooms}.',

	er_find_so_what_ratio: 'Большая часть изменения пришлась на {rooms}.',
	er_find_so_what_type: 'Главная жалоба: {name} ({percent}%).',
	er_hot_slowest: 'Помещения с самым долгим временем реакции',
	er_hot_expired_slas: 'Помещения, превысившие SLA',
	er_hot_ratio: 'Помещения с самым большим изменением доли жалоб',
	er_hot_top_type: 'Помещения с наибольшим числом жалоб «{name}»',
	er_hot_col_room: 'Помещение',
	er_col_response: 'Реакция',
	er_col_cleaners: 'Уборка',
	er_col_score: 'Балл',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Доля',
	er_hot_col_change: 'Изменение',
	er_hot_col_count: 'Кол-во',
	er_hot_empty: 'Нет заметных помещений в этом месяце.',
	er_hot_empty_range: 'Нет заметных помещений за этот период.',
	er_hot_empty_week: 'Нет заметных помещений на этой неделе.',
	er_cover_highlights: 'В этом месяце',
	er_cover_highlights_range: 'Этот период',
	er_cover_highlights_week: 'На этой неделе',
	er_cover_score_rose: 'Оценка впечатления выросла.',
	er_cover_score_eased: 'Оценка впечатления снизилась.',
	er_cover_response_improved: 'Время отклика улучшилось.',
	er_cover_response_slowed: 'Время отклика выросло.',
	er_cover_ratio_fell: 'Соотношение жалоб и визитов снизилось.',
	er_cover_ratio_rose: 'Соотношение жалоб и визитов выросло.',
	er_export_pdf: 'PDF панели',
	er_export_executive: 'Исполнительный отчёт',
	'executive-report': 'Исполнительный отчёт',
	er_export_csv: 'CSV',
	er_export_status_title: 'Создаём отчёт',
	er_export_status_fetch: 'Загружаем цифры',
	er_export_status_layout: 'Верстаем страницы',
	er_export_status_page: 'Страница {page} из {total}',
	er_footer_copyright: 'Этот отчёт сформирован системой BuzzzTech.',
	er_contact_line: 'Есть вопросы или хотите разобрать данные подробнее? Обратитесь в команду Customer Success BuzzzTech: {email} или {phone}.',
};
